import { APIResourceService } from '@/core/services/APIService'
import { Spectrum } from '@/core/resources/Spectrum'
import { VisibilitySpectrum } from '@/core/Common'
import { buildException } from '@/core/exceptions'

export class SpectraService extends APIResourceService<Spectrum> {
  constructor() {
    super(Spectrum)
  }

  /**
   * Appel API pour importer des spectres depuis un serveur
   * @param files Liste des chemins des fichiers à importer
   * @param serverId Identifiant du serveur
   * @param token Jeton de session
   * @return true si l'importation a réussi
   * @throws PolluxApiError si la modification a échoué
   */
  importSpectraFromServer(files: Array<string>, serverId: number, token: string): Promise<boolean> {
    const json = {
      files: files,
      server_id: serverId
    }
    return this.client
      .post('spectra', json, token)
      .then(() => true)
      .catch((err) => {
        throw buildException(err)
      })
  }

  /**
   * Appel API pour importer des spectres depuis des fichiers uploadés
   * @param token Jeton de session JWT
   * @param data Données du formulaire d'upload
   * @return true si l'importation a réussi
   * @throws PolluxApiError si la modification a échoué
   */
  importSpectraFromUpload(token: string, data: FormData): Promise<boolean> {
    return this.client
      .post('spectra', data, token)
      .then(() => true)
      .catch((err) => {
        throw buildException(err)
      })
  }

  /**
   * Appel API pour mettre à jour la visibilité d'une liste de spectres
   * @param spectra Liste des spectres à mettre à jour
   * @param visibility La visibilité à attribuer aux spectres
   * @param token Jeton de session JWT
   * @return true si l'opération a réussi
   * @throws PolluxApiError si la modification a échoué
   */
  updateSpectraVisibility(spectra: Array<string>, visibility: VisibilitySpectrum, token: string): Promise<boolean> {
    const json = {
      spectra: spectra,
      hidden: {
        [VisibilitySpectrum.DISPLAY]: '0',
        [VisibilitySpectrum.READY]: '1',
        [VisibilitySpectrum.HIDDEN]: '2'
      }[visibility]
    }
    return this.client
      .put('spectra/update_list', json, token)
      .then(() => true)
      .catch((err) => {
        throw buildException(err)
      })
  }
}
